import { Link } from 'react-router-dom';

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
  icon?: string;
}

export default function SectionHeading({ title, subtitle, linkTo, linkLabel, icon }: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div className="flex items-center gap-3">
        <span className="flex h-1.5 w-1.5 rounded-full bg-primary-500"></span>
        <div>
          <h2 className="flex items-center gap-2 text-xl font-bold text-foreground-950 md:text-2xl">
            {icon && <i className={`${icon} text-primary-500`}></i>}
            {title}
          </h2>
          {subtitle && <p className="mt-1 text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {linkTo && linkLabel && (
        <Link
          to={linkTo}
          className="hidden shrink-0 items-center gap-1 text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600 sm:inline-flex cursor-pointer"
        >
          {linkLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}